"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: 16
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 12
  }, /*#__PURE__*/_react.default.createElement(_antd.Statistic, {
    title: "Active Users",
    value: 112893
  })), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 12
  }, /*#__PURE__*/_react.default.createElement(_antd.Statistic, {
    title: "Account Balance (CNY)",
    value: 112893,
    precision: 2
  }), /*#__PURE__*/_react.default.createElement(_antd.Button, {
    style: {
      marginTop: 16
    },
    type: "primary"
  }, "Recharge")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 12
  }, /*#__PURE__*/_react.default.createElement(_antd.Statistic, {
    title: "Active Users",
    value: 112893,
    loading: true
  })));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorPrimary'],
  key: 'default'
};
var _default = exports.default = componentDemo;